import { render, staticRenderFns } from "./AddCustomerCare.vue?vue&type=template&id=05758913&scoped=true"
import script from "./AddCustomerCare.vue?vue&type=script&lang=js"
export * from "./AddCustomerCare.vue?vue&type=script&lang=js"
import style0 from "./AddCustomerCare.vue?vue&type=style&index=0&id=05758913&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05758913",
  null
  
)

export default component.exports